import DomainModel from '../../../domain-model';

export default class BaseProperties extends HTMLElement {

    model: DomainModel;

    constructor(model: DomainModel) {
        super();
        this.model = model;
    }
}
